module.exports = __webpack_public_path__ + "img/sort.76871fbe.svg";